import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { setupI18n } from "./i18n";
import { router } from "./router";
import { initializeTheme } from "./theme/preference";
import "./styles/theme.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

async function start() {
  initializeTheme();
  // VITE_MOCK=1 serves every /api call from src/client/mocks instead of the
  // Bun server. The import is dynamic so msw, a devDependency, never lands in
  // the production bundle.
  if (import.meta.env.VITE_MOCK === "1") {
    const { startMockBackend } = await import("./mocks/browser");
    await startMockBackend();
  }
  await setupI18n();
  const root = document.getElementById("root");
  if (!root) throw new Error("#root missing");
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
